const map_CN_Locale = {
    'map.contactPhone': '联系电话:',
    'map.contactPhoneContent': '0755-8696 9948',
    'map.contactEmail': '联系邮箱:',
    'map.contactAddress': '联系地址:',
    'map.contactAddressContent': '深圳市南山区桃源街道长源社区学苑大道1001号南山智园D1栋16层',
    'map.workingHours': '工作时间:',
    'map.workingHoursContent': '周一至周五',
    'map.workingHoursContent1': '(9:00-18:30)',
    'map.consultation': '欢迎来电咨询'
}
export default map_CN_Locale
